import React from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import securityIcon from '../../../assets/icons/key-icon.svg'
import "./security-section.scss";

type Props = {
  onChangePassword?: () => void;
};

const SecuritySection: React.FC<Props> = ({ onChangePassword }) => {
  return (
    <Box className="preneed-profile-form__security">
      <Typography className="preneed-profile-form__securityTitle">
        Security
      </Typography>

      <Typography className="preneed-profile-form__securitySub">
        Manage your password and security settings
      </Typography>

      <Box
        className="preneed-profile-form__securityRow"
        onClick={onChangePassword}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onChangePassword?.();
        }}
      >
        <Box className="preneed-profile-form__securityLeft">
          <Box className="preneed-profile-form__securityIcon">
            <img src={securityIcon} alt="Security" />
          </Box>

          <Box>
            <Box className="preneed-profile-form__securityRowTitle">
              Change Password
            </Box>
            <Box className="preneed-profile-form__securityRowSub">
              Update your account password
            </Box>
          </Box>
        </Box>

        <ChevronRightIcon sx={{ color: "#9ca3af" }} />
      </Box>
    </Box>
  );
};

export default SecuritySection;
